import React, { Component, Fragment } from "react";
import { message } from "antd";
import { getQueryString } from "../../utils/utils";
import { burying } from "../../utils/buryPoint";
import { challengeResult, fetchPunishDetailData, getPunishDetail, needChallenge } from "../../services/services";
import GeneralButton from "../../components/generalButton";
import Loading from "../../components/loading";
import {
  punishDetailType,
  detailInfoListType,
  showPunishCfgType,
} from "../../services/interfaceType";
import { withRouter } from "react-router-dom";
import back from "../../static/images/back.png";
import styles from "./index.less";

interface Props {
  history: any;
}
interface State {
  punishDetailData: punishDetailType;
  loading: boolean;
}
class Punish extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      punishDetailData: {},
      loading: true,
    };
  }

  componentDidMount() {
    document.body.scrollTop = 0;
    const punishId = getQueryString("punishId");
    const punishLine = getQueryString("punishLine");
    this.getPunishDetailData(punishId, punishLine);
  }

  /**
   * @description 获取处罚详情数据
   *
   **/
  getPunishDetailData = async (
    punishId: string | number,
    punishLine: string | number
  ) => {
    const templateId = getQueryString("templateId");
    const isWlPunish = getQueryString("isWlPunish") === 'true';
    const params = {
      templateId,
      punishId,
      punishLine,
    };
    const result = isWlPunish ? await getPunishDetail({ templateId }) : await fetchPunishDetailData(params);
    if (result) {
      if (result.code === 0) {
        this.setState({
          punishDetailData: result.data,
        });
        burying(
          "1",
          "punish-detail-page",
          `status=${result.data.punishStatus}$punishid=${punishId}`,
          "ss-02",
          "undefined"
        );
      } else {
        message.info(result.msg);
      }
      this.setState({
        loading: false,
      });
    } else {
      this.props.history.push("/case/home/error");
    }
  };

  /**
   * @description 配置文字提示以及按钮
   *
   **/
  configurationInformation = (
    showPunishConfig: showPunishCfgType | undefined,
    caseButtonType: number,
    punishStatus: number,
    punishId: number
  ) => {
    if (showPunishConfig && showPunishConfig.tipsJSON) {
      const { end, start, text, url } = showPunishConfig.tipsJSON;
      burying(
        "2",
        "move-punish-detail",
        `button=${text.slice(
          start - 1,
          end
        )}$status=${punishStatus}$punishid=${punishId}`,
        "ss-02",
        "undefined"
      );
      return (
        <div className={styles.punishDetailTips}>
          <div>
            {text.slice(0, start - 1)}
            <i
              onClick={() => {
                this.onTipsClick(url);
              }}
            >
              {text.slice(start - 1, end)}
            </i>
            {text.slice(end)}
          </div>
        </div>
      );
    } else if (
      caseButtonType === -1 &&
      showPunishConfig &&
      showPunishConfig.buttonText
    ) {
      return (
        <GeneralButton
          buttonText={showPunishConfig.buttonText}
          type="middle"
          styleColor="activation"
          buttonClick={() => {
            burying(
              "2",
              "operate-punish-detail",
              `button=${showPunishConfig.buttonText}$status=${punishStatus}$punishid=${punishId}`,
              "ss-02",
              "undefined"
            );
            this.configButtonLink(showPunishConfig.buttonUrl);
          }}
        />
      );
    } else {
      return null;
    }
  };

  configButtonLink = (url) => {
    window.open(url);
  };

  /**
   * @description 返回列表页
   *
   **/
  linkToList = () => {
    this.props.history.goBack();
  };

  onTipsClick = (url) => {
    window.open(url);
  };

  appealClick = (illegalType: number, punishNames: any[], punishId: string | number) => {
    const templateId = getQueryString("templateId");
    if (illegalType == 1 && punishNames[0] === '微聊禁言') {
      // 非虚假类罚单
      this.handleChallenge(punishId);
      return;
    } else {
      this.props.history.push(
        `/case/home/appealentrance?templateId=${templateId}&punishId=${punishId}`
      );
    }

  };

  handleChallenge = async (punishId: string | number) => {
    const self = this
    const templateId = getQueryString('templateId');
    // 获取挑战结果
    const challengeRes = await needChallenge({ templateId });
    // 如果需要挑战则唤起挑战
    if (challengeRes.data.needChallenge) {
      const { accessPartyID, appID, sceneID, challengeLevel, sessionID, userID } = challengeRes.data;
      window.yChallenge({
        appId: appID,
        sceneId: sceneID,
        additional: {
          challengelevel: String(challengeLevel)
        },
        sessionId: sessionID,
        userId: userID,
        accesspartyId: accessPartyID,
        callback: async function (result: any) {
          if (result && result.code === 0) {
            const challengeRes = await challengeResult({ templateId, token: result.token });
            if (challengeRes && challengeRes.code === 0) {
              message.success('挑战成功');
              self.handlePunish();
            } else {
              message.success('挑战失败');
              window.location.reload();
            }
          } else {
            message.success('挑战失败');
            window.location.reload();
          }

        },
      })
    } else {
      self.handleAppeal(punishId)
    }
  }
  handlePunish = () => {
    const templateId = getQueryString('templateId');
    this.props.history.push(`/case/home/punish/list?templateId=${templateId}`);
  }
  handleAppeal = (punishId: string | number) => {
    const templateId = getQueryString('templateId');
    this.props.history.push(
      `/case/home/appealentrance?templateId=${templateId}&punishId=${punishId}`
    );
  }

  appealDetailClick = (caseId: string | number, appealStatus: number) => {
    const templateId = getQueryString("templateId");
    this.props.history.push(
      `/case/home/detail/${caseId}?templateId=${templateId}&caseId=${caseId}&appealStatus=${appealStatus}`
    );
  };

  handleRenderPunishCard = (detailJsonConfig: any) => {
    let headImg = "",
      title = "",
      info = "",
      status = "",
      content = "",
      imgList = [];
    detailJsonConfig.map((item: any, index: number) => {
      switch (item.module) {
        case 1:
          headImg = item.value;
          break;
        case 2:
          title = item.value;
          break;
        case 3:
          info = item.value;
          break;
        case 4:
          status = item.value;
          break;
        case 5:
          content = item.value;
          break;
        case 6:
          imgList = item.value;
          break;
      }
    });
    return detailJsonConfig && detailJsonConfig.length > 0 ? (
      <div className={styles.cardContent}>
        <div className={styles.cardinfo}>
          {headImg ? (
            <div className={styles.headImg}>
              <img src={headImg} />
            </div>
          ) : null}
          <div className={styles.information}>
            {title ? (
              <div
                className={styles.title}
                style={{ WebkitBoxOrient: "vertical" }}
              >
                {title}
              </div>
            ) : null}
            <div className={styles.info}>
              {info ? <span>信息ID：{info}</span> : null}
              {status ? (
                <span>
                  <i>{status}</i>
                </span>
              ) : null}
            </div>
          </div>
        </div>
        <div className={styles.cardContainer}>
          {content ? (
            <div
              className={styles.description}
              style={{ WebkitBoxOrient: "vertical" }}
            >
              {content}
            </div>
          ) : null}
          {imgList && imgList.length > 0 ? (
            <div className={styles.picture}>
              {imgList.map((item: string, index: number) => (
                <img src={item} key={index} />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    ) : null;
  };

  //   end: 22
  // start: 16
  // text: "避免再次违规被处罚，请点击查看：平台微聊规范"
  // tipsProtocolType: 1
  // url: "https://helps.58.com/train/detail?siteId=5502&terminal=PC&contentId=200119&sourceType=58pc-xa-cfss-wdcf&spReturn=1"
  handleUserEducation = (userEducation: any) => {
    const { end, start, text, url } = userEducation;
    return (
      <div
        onClick={() => {
          window.open(url);
        }}
        className={styles.userEducation}
      >
        <span>{text.slice(0, start)}</span>
        <span style={{ color: "#1790FF" }}>{text.slice(start, end)}</span>
        <span>{text.slice(end)}</span>
      </div>
    );
  };

  render() {
    const { punishDetailData, loading } = this.state;
    const {
      punishId,
      appealStatus,
      caseButtonType,
      caseId,
      detailInfoList,
      punishDetailJsonArray,
      punishNames,
      punishReason,
      punishStatus,
      punishTime,
      recovery,
      showPunishConfig,
      userEducation,
      illegalType,
      endTime,
      // hoursId
    } = punishDetailData;
    const templateId = getQueryString("templateId");
    // changelog: 给U+系统内嵌入，隐藏返回按钮和底部申诉按钮
    const hideBackBtn = getQueryString("backBtn") === 'hide';
    // 是否是微聊禁言
    const isWeiliaoPunish = punishNames && punishNames[0] === '微聊禁言';
    // 是否是微聊禁言或者消息拦截
    const isWeiliao = isWeiliaoPunish || !this.state.punishDetailData.weiLiaoType;
    const reasonList = punishReason ? punishReason.split('|') : [];
    return (
      <div style={{ width: templateId === "2" ? "" : "815px" }}>
        <div className={styles.punishDetail}>
          <div className={styles.punishTitle}>
            <span className={styles.name}>处罚详情</span>
            {!hideBackBtn && <div className={styles.goBack} onClick={this.linkToList}>
              <img src={back} />
              <span>返回列表</span>
            </div>}
          </div>
          {loading ? (
            <Loading />
          ) : (
            <Fragment>
              <div className={styles.punishInfo}>
                <div className={styles.punishCard}>
                  <span className={styles.punishStauts}>
                    {appealStatus === 5
                      ? "处罚维持原判"
                      : appealStatus === 4 ||
                        punishStatus === 3 ||
                        punishStatus === 2 ||
                        recovery
                        ? "处罚已撤销"
                        : "已处罚"}
                  </span>
                  <div className={styles.punishContent}>
                    {!isWeiliaoPunish && <span>处罚编号：{punishId}</span>}
                    <span>
                      处罚方式：
                      {punishNames &&
                        punishNames.map((item: string, index: number) => {
                          return (
                            <i key={index}>
                              {item}
                              {index !== punishNames.length - 1 ? "," : ""}
                            </i>
                          );
                        })}
                    </span>
                    {isWeiliaoPunish && <span className={styles.punishType}>截止时间：{endTime}</span>}
                    <span>处罚时间：{punishTime}</span>
                  </div>
                </div>
              </div>
              <div className={styles.punishReason}>
                <div className={styles.reasonTitle}>处罚原因</div>
                <div className={styles.reasonContent}>
                  {reasonList.length > 0 ? reasonList.map((reason: string, index: number) =>
                    <div
                      className={styles.wlReason}
                      style={{ WebkitBoxOrient: "vertical" }}>
                      {reasonList.length > 1 ? `${index + 1}. ${reason}` : `${reason}`}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className={styles.punishParticulars}>
                {!isWeiliao && <>
                  <div className={styles.particularsTitle}>处罚明细</div>
                  <ul className={styles.particularsList}>
                    {detailInfoList &&
                      detailInfoList.map(
                        (item: detailInfoListType, index: number) => {
                          return (
                            <li key={index} className={styles.singleList}>
                              <div className={styles.singleItem}>
                                处罚记录：<i>{item.punishName}</i>
                              </div>
                              <div className={styles.singleItem}>
                                处罚内容：<i>{item.punishedObjId}</i>
                              </div>
                            </li>
                          );
                        }
                      )}
                    {punishDetailJsonArray &&
                      punishDetailJsonArray.map((item: any, index: number) => {
                        return (
                          <li key={index} className={styles.singleList}>
                            <div className={styles.singleItem}>
                              处罚记录：<i>{item.punishName}</i>
                            </div>
                            <div className={styles.singleItem}>
                              处罚内容：
                              {this.handleRenderPunishCard(item.detailJsonConfig)}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </>}

                {userEducation ? this.handleUserEducation(userEducation) : null}
              </div>

              {!hideBackBtn && <div className={styles.configurationInformation}>
                {this.configurationInformation(
                  showPunishConfig,
                  caseButtonType,
                  punishStatus,
                  punishId
                )}
                {caseButtonType === 1 ? (
                  <GeneralButton
                    buttonText="查看申诉详情"
                    type="middle"
                    styleColor="activation"
                    buttonClick={() => {
                      burying(
                        "2",
                        "operate-punish-detail",
                        `button='查看申诉详情'$status=${punishStatus}$punishid=${punishId}`,
                        "ss-02",
                        "undefined"
                      );
                      this.appealDetailClick(caseId, appealStatus);
                    }}
                  />
                ) : caseButtonType === 2 ? (
                  <GeneralButton
                    buttonText="申诉"
                    type="middle"
                    styleColor="activation"
                    buttonClick={() => {
                      burying(
                        "2",
                        "operate-punish-detail",
                        `button='申诉'$status=${punishStatus}$punishid=${punishId}`,
                        "ss-02",
                        "undefined"
                      );
                      if (illegalType == 2) {
                        message.info('请到58同城APP："我的—客户服务—处罚申诉"找到对应处罚记录提交申诉');
                        // window.location.href = `https://zfang.58.com/post/pc/houseappeal?houseId=${hoursId}`;
                      } else {
                        this.appealClick(illegalType, punishNames, punishId);
                      }
                    }}
                  />
                ) : null}
              </div>}
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Punish);
